import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { CompanyLocation } from 'types/companyLocation.types';

const LIST_COMPANY_LOCATIONS_QUERY = gql`
  query ListCompanyLocations($excludeHidden: Boolean) {
    companyLocations(excludeHidden: $excludeHidden) {
      id
      name
    }
  }
`;

type ListCompanyLocationsQueryResult = {
  companyLocations: CompanyLocation[];
};

const companyLocationsApi = {
  list: async (excludeHidden: boolean = true): Promise<ListCompanyLocationsQueryResult> =>
    gqlClient.request<ListCompanyLocationsQueryResult>(LIST_COMPANY_LOCATIONS_QUERY, {
      excludeHidden
    })
};

export { companyLocationsApi };
